export default "__VITE_ASSET__D6iE4$lc__"